<template>
  <span class="d-inline-block" style="margin-top: -4px;">
    <b-btn size="sm" @click.prevent="onClick" class="vgt-left-btn">
      <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-paperclip" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
          d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z" />
      </svg>
      Upload File
    </b-btn>
    <input type="file" ref="fileInput" @change="onFileChanged" class="d-none" accept=".csv, .xlsx">

    <b-modal ref="modal" size="xlg" lazy @hide-footer="true" :title="title" @hide="onHide">
      <div class="import--container">
        <div class="row">
          <div class="col-sm-12">
            <Alerts />
            <LoadingSpinner v-if="isLoading" />

            <div v-if="view === 'mapping'">
              <b-row>
                <b-col cols="8">
                  <table class="table mapping-table">
                    <thead>
                      <tr>
                        <th>Your File's Column Headers</th>
                        <th width="100"></th>
                        <th>GrandShipper Fields</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(header, i) in headers" :key="i">
                        <td class="text-right">{{ header }}</td>
                        <td> =</td>
                        <td>
                          <b-select :options="field_options" v-model="field_map[i]" @change="val => {
                            field_map = _.map(field_map, (field, index) => {
                              if(field === val && index != i) {
                                field = null;
                              }
                              return field;
                            })
                          }" size="lg" class="d-block w-100">
                          </b-select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
                <b-col>
                  <label-preview :origin="origin" :label="label_preview" style="max-width: 350px"></label-preview>
                </b-col>
              </b-row>

              <!--

              <b-table striped hover :items="rows" :fields="tableFields">
                <template v-for="(a, i) in mappingTableFields" :slot="`HEAD_${i}`" slot-scope="data">
                  <b-select :options="field_options" v-model="field_map[i]"></b-select>
                </template>

                <template slot="index" slot-scope="row">
                  <b-form-checkbox
                    :id="'selected' + (row.index + 1)"
                    v-model="deselected"
                    :value="row.index"
                    @change="onDeselect()"
                  ></b-form-checkbox>
                </template>

                <template slot="field" slot-scope="row">
                  <b-select :options="field_options" v-model="field_map[i]"></b-select>
                </template>

              </b-table>
              -->
            </div>

            <b-form v-else-if="!isDone" @submit="onSubmit">
              <!--
              <b-form-group label="File" label-for="file" description="File formats: csv, xlsx">
                <b-form-file
                  plain
                  id="file"
                  ref="file"
                  :state="Boolean(file)"
                  class="form-control-file"
                  placeholder="Choose a file..."
                  accept=".csv, .xlsx"
                  @change="onFileChanged"
                ></b-form-file>
              </b-form-group>
              -->

              <b-table striped hover :items="rows" :fields="tableFields">
                <template v-for="(a, i) in tableFields" :slot="`HEAD_${i}`" slot-scope="data">
                  <b-select :options="field_options" v-model="field_map[i]"></b-select>
                </template>

                <template slot="index" slot-scope="row">
                  <b-form-checkbox :id="'selected' + (row.index + 1)" v-model="deselected" :value="row.index"
                    @change="onDeselect()"></b-form-checkbox>
                </template>
              </b-table>
            </b-form>

            <div v-if="isDone">
              <h3>
                Orders imported! They have been added to
                <router-link to="/orders/pending">Pending Orders</router-link>.
              </h3>
            </div>
          </div>
        </div>
      </div>

      <div slot="modal-footer">
        <div v-if="!isDone">
          <b-button type="submit" variant="primary" size="lg" @click="onSubmit">Import Contacts</b-button>
        </div>

        <div v-else>
          <b-button type="button" variant="primary" @click="restart()">Back</b-button>
        </div>
      </div>
    </b-modal>
  </span>
</template>
<style lang="scss" scoped>
.mapping-table {
  font-size: 18px;
}
</style>

<script>
import Papa from "papaparse";
import numeral from "numeral";
import XLSX from "xlsx";
import LoadingSpinner from "./LoadingSpinner";
import Alerts from "./Alerts";

function urltoFile(url) {
  return fetch(url)
    .then(res => res.blob())
    .then(blob => {
      console.log("blob", blob);
      return new File([blob], "File name");
    });
}

export default {
  components: {
    LoadingSpinner,
    Alerts
  },
  props: {
    orderStatusId: Number // order status to query
  },
  data() {
    return {
      isLoading: false,
      view: "mapping",
      isDone: false,
      file: null,
      deselected: [],
      rows: [],
      field_map: [],
      origin: {
        default: false,
        id: null,
        name: null,
        first_name: null,
        last_name: null,
        company: null,
        address: null,
        city: null,
        state: null,
        postal: null,
        postal_origin: null,
        country: 'US',
        phone: null
      },
      cols: {
        acct_id: "Account ID",
        first_name: "First Name",
        last_name: "Last Name",
        company: "Company",
        address: "Address",
        address2: "Address 2",
        city: "City",
        state: "State/Province",
        country: "Country",
        postal_code: "Postal Code",
        phone: "Phone #",
        email: "E-Mail",
      },
      // cols: {
      //   acct_id: {
      //     name: "Account ID",
      //   },
      //   first_name: {
      //     name: "First Name",
      //     rules: ["This field is required. (At least one field is required)"]
      //   },
      //   last_name: {
      //     name: "Last Name",
      //     rules: ["This field is required. (At least one field is required)"]
      //   },
      //   company: {
      //     name: "Company",
      //     rules: ["This field is required. (At least one field is required)"]
      //   },
      //   address: {
      //     name: "Address",
      //     rules: ["This field is required."]
      //   },
      //   address2: {
      //     name: "Address 2",
      //   },
      //   city: {
      //     name: "City",
      //     rules: ["This field is required."]
      //   },
      //   state: {
      //     name: "State/Province",
      //     rules: ["This field is required."]
      //   },
      //   country: {
      //     name: "Country",
      //   },
      //   postal_code: {
      //     name: "Postal Code",
      //     rules: ["This field is required."]
      //   },
      //   phone: {
      //     name: "Phone #",
      //   },
      //   email: {
      //     name: "E-Mail",
      //   },
      // }
    };
  },
  computed: {
    title() {
      if (this.view === 'mapping') {
        return 'Confirm Field Mapping'
      }
      return 'Import Contacts';
    },
    num_columns() {
      if (this.rows[0]) {
        return this.rows[0].length;
      }
      return 0;
    },
    headers() {
      if (this.rows[0]) {
        return this.rows[0];
      }
      return [];
    },
    field_options() {
      let options = _.map(this.cols, (text, value) => {
        return {
          value,
          text
        };
      });

      return [
        {
          value: null,
          text: "-- Ignore --"
        },
        ...options
      ];
    },
    tableFields() {
      let fields = [{ key: "index", label: "Deselect" }];

      for (var i = 0; i < this.num_columns; i++) {
        fields.push({
          key: i.toString(),
          label: ""
        });
      }

      return fields;

      // for (var i = 0; i < this.cols.length; i++) {
      //   const label = this.cols[i];

      //   let obj = {
      //     key: i.toString(),
      //     label: label
      //   };

      //   if (label in ["Total"]) {
      //     obj.formatter = cell => {
      //       return numeral(cell).format("$0,0.00");
      //     };
      //   }

      //   fields.push(obj);
      // }

      // return fields;
    },
    label_preview() {
      if (!this.rows[1]) {
        return {}
      }

      let map = _.invert(this.field_map)
      return {
        name: this.rows[1][map.buyer] || null,
        first_name: this.rows[1][map.first_name] || null,
        last_name: this.rows[1][map.last_name] || null,
        company: this.rows[1][map.company] || null,
        address: this.rows[1][map.address] || null,
        address2: this.rows[1][map.address2] || null,
        city: this.rows[1][map.city] || null,
        state: this.rows[1][map.state] || null,
        postal_code: this.rows[1][map.postal_code] || null,
        country: this.rows[1][map.country] || null,
        label_sticky: this.rows[1][map.label_sticky] || null,
        label_sticky_2: this.rows[1][map.label_sticky_2] || null,
      }
    }
  },
  async mounted() {
    this.field_map = Cookies.getJSON(`import-addresses-fieldmap`) || {};

    await axios.get("user/addresses").then(response => {
      if (response.data.length > 0) {
        let selected = _.find(response.data, addr => addr.is_default);
        if (!selected) {
          selected = response.data[0]
        }
        this.origin = selected;
      }
    });
  },
  methods: {
    onClick() {
      this.$refs.fileInput.value = null;
      this.$refs.fileInput.click();
      //this.show();
    },

    show() {
      this.$refs.modal.show();
    },

    hide() {
      this.$refs.modal.hide();
    },

    onHide() { },

    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsBinaryString(file);
      });
    },

    async onFileChanged(e) {
      this.isLoading = true;
      this.view = "mapping";
      this.rows = [];
      this.$emit("alert_close");

      let file = e.target.files[0];

      let content = null;
      let type = null;

      if (/\.csv$/i.test(file.name)) {
        type = "csv";
      } else if (/\.xlsx$/i.test(file.name)) {
        type = "xlsx";
      } else {
        this.$parent.$emit("alert", {
          message: "Invalid format. Please provide a CSV or XLS file.",
          type: "danger"
        });
        this.isLoading = false;
        return;
      }

      try {
        content = await this.readFileAsync(file);
      } catch (e) {
        this.$parent.$emit("alert", {
          message: "Failed to read file",
          type: "danger"
        });
        this.isLoading = false;
        return;
      }

      if (type === "xlsx") {
        const workbook = XLSX.read(content, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        content = XLSX.utils.sheet_to_csv(sheet);
      }

      const result = Papa.parse(content);

      result.data = _.filter(result.data, row => {
        let valid = true;

        if (!row.join("")) {
          return false;
        }

        return valid;
      });

      // empty
      if (!result.data.length) {
        this.$parent.$emit("alert", {
          message: "Invalid file: no rows present",
          type: "danger"
        });
        this.isLoading = false;
        return;
      }

      /*
      if (result.data[0].length !== this.getNumFields()) {
        this.$parent.$emit("alert", {
          message:
            "Invalid file: the number of columns should be " +
            this.getNumFields() +
            " exactly.<br>" +
            "<a href='/storage/import-example.csv'><u>Download template</u></a>",
          type: "danger"
        });
        this.isLoading = false;
        return;
      }
      */

      this.rows = result.data;
      this.show();
      this.isLoading = false;
    },

    onSubmit(e) {
      e.preventDefault();

      this.isLoading = true;

      const selectedRows = this.rows.filter(
        (row, key) => !this.deselected.includes(key)
      );

      Cookies.set(`import-addresses-fieldmap`, this.field_map, { expires: 30 });

      // console.log("selected Rows:", selectedRows)
      // console.log("field maps: ", this.field_map)
      if (selectedRows.length <= 5001) {
        axios
          .post("/addresses/import", {
            rows: JSON.stringify(selectedRows),
            field_map: this.field_map,
            order_status_id: this.orderStatusId
          })
          .then(response => {
            this.$emit('imported')
            this.$refs.modal.hide();
            this.restart();
            // setTimeout(() => {
            //   this.$destroy();
            // }, 1000);
          })
          .catch(error => {
            const { response: { data: { errors, message } } } = error;
            console.error("Err message: ", message)
            console.error("Err Fields: ", errors)
            let errorMessage = message;
            if (errors) {
              errorMessage = errors.reduce((all, current) => {
                return `${all} &nbsp;&nbsp;- ${current} <br />`
              }, "Plase double check CSV File: <br />")
            }
            console.error(error.response.data.errors);
            this.$parent.$emit("alert", {
              message: errorMessage.trim(),
              type: "danger",
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$parent.$emit("alert", {
          message: `${selectedRows.length} records is too big. Maximum allowed records per upload is 5000.`,
          type: "danger",
        });
        this.isLoading = false;
      }
    },

    restart() {
      this.isLoading = false;

      this.isDone = false;
      this.file = null;
      this.rows = [];
    },

    onDeselect(val) {
      console.log(val);
    },

    getNumFields() {
      return this.tableFields.length - 1;
    }
  },
  watch: {
    deselected: function (newVal, oldVal) {
      this.rows = this.rows.map((row, key) => {
        row._rowVariant = newVal.includes(key) ? "danger" : "";
        return row;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ImportAddressesButton.vue